import request from "@/utils/request";

export const getServices = () => request.get("/my-services");
